import React from "react";
import { Select } from "antd";

const SrtDropDown = (props) => {
  const sourceData = props?.options || [];

  const handleChange = (val) => {
    // CLEAR
    if (!val || (Array.isArray(val) && val.length === 0)) {
      props.onChange(props.mode === "multiple" ? [] : undefined);
      return;
    }

    // MULTIPLE MODE
    if (props.mode === "multiple") {
      if (props.enableSelectAll && val.includes("ALL")) {
        const allValues = sourceData
          .filter((item) => item.value !== "ALL")
          .map((item) => item.value);

        props.onChange(allValues);
        return;
      }

      props.onChange(val);
      return;
    }

    // SINGLE MODE
    props.onChange(val);
  };

  return (
    <Select
      mode={props.mode} // ✅ multiple supported
      allowClear={props.allowClear}
      placeholder={props.placeholder}
      value={props.value}
      style={{ width: 180 }}
      options={sourceData}
      onChange={handleChange}
      onClear={props.onClear}
      showSearch
      optionFilterProp="label"
      filterOption={(input, option) =>
        option?.label?.toLowerCase().includes(input.toLowerCase())
      }
      disabled={props.disabled}
    />
  );
};

export default SrtDropDown;
